import { OTHER_OPTION } from "./FieldState";

function getSelectMultipleOrOtherOptions<
  T extends { label: string; value: any },
>(options: Array<T>, allowOther?: boolean): Array<T> {
  return [...options, ...(allowOther ? [OTHER_OPTION as T] : [])];
}

export default getSelectMultipleOrOtherOptions;
